module.exports = __webpack_public_path__ + "static/media/adler-3366239_640-min.82d51e13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adler-3366239_640-min.jpg
// module id = 131
// module chunks = 0